export default "/assets/images/homewrecker-filter.29bd0a6df566e279.png";